<template>
  <div class="col-12 ">
    <div class="card mb-5" style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">{{ t('assignmentForm.editTitle') }}</h6>
          </div>
        </div>
      </div>

      <LoadingSpinner v-if="isLoading" :message="t('assignmentForm.loading')" />

      <AssignmentForm
        v-else-if="assignment"
        :initial-data="prepareAssignmentData(assignment)"
        :is-loading="isUpdating"
        :is-edit-mode="true"
        :submit-text="t('assignmentForm.saveButton')"
        @submit="updateAssignment"
        @cancel="navigateBack"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from 'vue-i18n';
import AssignmentForm from "@/components/features/assignments/AssignmentForm.vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import api from "@/api";
import { useToast } from 'vue-toastification';

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const toast = useToast();

const isLoading = ref(false);
const isUpdating = ref(false);
const assignment = ref(null);

const prepareAssignmentData = (assignment) => ({
  id: assignment.id,
  title: assignment.title,
  description: assignment.description,
  due_date: assignment.due_date,
  class_id: assignment.class_id,
  group_id: assignment.group_id || assignment.group?.id,
  subject_id: assignment.subject_id,
  teacher_id: assignment.teacher_id
});

const fetchAssignment = async () => {
  isLoading.value = true;
  try {
    const response = await api.get(`/assignments/${route.params.id}`);
    assignment.value = response.data.data;
  } catch (error) {
    toast.error(t('assignmentForm.errorLoad'));
    console.error("Error fetching assignment:", error);
    router.push({ name: 'assignments.index' });
  } finally {
    isLoading.value = false;
  }
};

const updateAssignment = async (formData) => {
  isUpdating.value = true;
  try {
    await api.put(`/assignments/${route.params.id}`, formData);
    toast.success(t('assignmentForm.successUpdate'));
    router.push({ name: 'assignments.index' });
  } catch (error) {
    if (error.response?.status === 422) {
      toast.error(t('assignmentForm.validationError'));
    } else {
      toast.error(error.response?.data?.message || t('assignmentForm.errorUpdate'));
    }
    console.error("Error updating assignment:", error);
  } finally {
    isUpdating.value = false;
  }
};

const navigateBack = () => {
  router.push({ name: 'assignments.index' });
};

onMounted(() => fetchAssignment());
</script>
